/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterMetal_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_viewer">;
    readonly " $refType": "SbSharedRefineMenuFilterMetal_viewer";
};
export type SbSharedRefineMenuFilterMetal_viewer$data = SbSharedRefineMenuFilterMetal_viewer;
export type SbSharedRefineMenuFilterMetal_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilterMetal_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterMetal_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterMetal_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '2798c6c2ba1ab8f683b56930ca3d69ce';
export default node;
